// ----------------------------------------------------------------------

export default function Tooltip(theme) {
  const isLight = theme.palette.mode === 'light'

  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: isLight ? '#262626' : '#2C3440',
          color: '#F4F3EE',
          fontSize: theme.typography.pxToRem(13),
          lineHeight: 1.45,
          fontWeight: 400,
          padding: theme.spacing(0.75, 1.25),
          borderRadius: theme.shape.borderRadius,
        },
        arrow: {
          color: isLight ? '#262626' : '#2C3440',
        },
      },
    },
  }
}
